import React, { useState, useEffect } from "react";
import {
  Button,
  FormFieldSet,
  useFormHandler,
} from "../../../../../components";
import { useDispatch, useSelector } from "react-redux";
import { getCompanyDetailsStart, getCompanyDetailsSuccess, saveCompanyDetailsStart } from "../../../../../redux/slices/setting/settingsSlice";

const GeneralDetails = () => {
  const [validationRules, setValidationRules] = useState({});
  const [disabled, setDisabled] = useState(true);
  const [buttonText, setButtonText] = useState("Edit");
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state?.auth);
  const [phone, setPhone] = useState({ code: "", number: ""});
   const savedGeneralDetails = useSelector(
    (state) => state.settings.companyProfile?.generalDetails
  );
  const initialFormData = {
    companyName: "",
    displayName: "",
    website: "",
    companyContact: "",
    panNumber: "",
    description: "",
  };
  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(initialFormData, validationRules);

  // const handleSubmit = async () => {
  //   const isValid = await validateAllFields();
  // };
   const handleSubmit = async () => {
    const isValid = await validateAllFields();
    if (!isValid) return;

    const payload = {
      id: user?.data?.organizationId._id,
      payload: {
        $set: {
          name: formData.companyName,
          displayName: formData.displayName,
          website: formData.website,
          panNum: formData.panNumber,
          description: formData.description,
          contactInformation: [
        {
          mobile: {
            primary: {
              code: phone.code,
              number: phone.number,
            },
            secondary: null,
          },
        },
      ],
        },
      },
    };

    dispatch(saveCompanyDetailsStart(payload));
  };

  useEffect(() => {
    const baseRules = {
      companyName: {
        type: "text",
        required: true,
      },
      displayName: {
        type: "text",
        required: true,
      },
      website: {
        type: "text",
        required: true,
      },
      // companyContact: {
      //   type: "text",
      //   required: true,
      // },
      panNumber: {
        type: "text",
        required: true,
      },
    };
    setValidationRules(baseRules);
  }, []);

  const handleButtonClick = () => {
    if (disabled) {
      setDisabled(false);
      setButtonText("Save");
    } else {
      const isValid = validateAllFields();

    if (!isValid) {
      // If validation fails, prevent save
      return;
    }
      handleSubmit();
      setDisabled(true);
      setButtonText("Edit");
    }
  };
    useEffect(() => {
      if (
        !savedGeneralDetails ||
        (!savedGeneralDetails.name &&
          !savedGeneralDetails.displayName &&
          !savedGeneralDetails.website)
      ) {
        dispatch(
          getCompanyDetailsStart({
            coll: "Organization",
            fil: { uiid: { type: "NONE", value: user?.data.organizationId.uiid } },
            ret: "name displayName website panNum description contactInformation",
          })
        );
      }
    }, [dispatch, user, savedGeneralDetails]);

  useEffect(() => {
    if (savedGeneralDetails) {
      setFormData({
        companyName: savedGeneralDetails?.name || "",
        displayName: savedGeneralDetails?.displayName || "",
        website: savedGeneralDetails?.website || "",
        panNumber: savedGeneralDetails?.panNum || "",
        description: savedGeneralDetails?.description || "",
      });
      const contact = savedGeneralDetails?.contactInformation?.[0];
    if (contact?.mobile?.primary) {
      setPhone({
        code: contact.mobile.primary?.code || "",
        number: contact.mobile.primary?.number || "",
      });
    }
    }
  }, [savedGeneralDetails, setFormData]);
  return (
    <div className="flex flex-col justify-between h-full p-4">
      <div className="xl:mr-40 grid grid-cols-2 xl:grid-cols-3 gap-x-4 gap-y-5">
        <FormFieldSet
          label="Input"
          title="Company Name"
          type="text"
          placeholder="Enter Company Name"
          disabled={disabled}
          value={formData.companyName}
          onChange={(value) => handleChange("companyName", value)}
          error={errors.companyName}
        />
        <FormFieldSet
          label="Input"
          title="Display Name"
          type="text"
          placeholder="Enter Display Name"
          disabled={disabled}
          value={formData.displayName}
          onChange={(value) => handleChange("displayName", value)}
          error={errors.displayName}
        />
        <FormFieldSet
          label="Input"
          title="Website"
          type="text"
          placeholder="Enter Website URL"
          disabled={disabled}
          value={formData.website}
          onChange={(value) => handleChange("website", value)}
          error={errors.website}
        />
        {/* <FormFieldSet
          label="Input"
          title="Company Contact"
          type="text"
          placeholder="Enter Company Contact"
          disabled={disabled}
          value={formData.companyContact}
          onChange={(value) => handleChange("companyContact", value)}
          error={errors.companyContact}
        /> */}
        <FormFieldSet
          title="Company Contact"
          type="phone"
          placeholder="Enter Company Contact"
          disabled={disabled}
          value={phone.number || ""}
          code={phone.code || ""}
          onChange={(fullValue, details) =>
            setPhone({
              code: details.countryCode,
              number: details.number,
            })
          }
          shadow
        />
        <FormFieldSet
          label="Input"
          title="PAN Number"
          type="text"
          placeholder="Enter PAN Number"
          disabled={disabled}
          value={formData.panNumber}
          onChange={(value) => handleChange("panNumber", value)}
          error={errors.panNumber}
        />
        <div className="col-span-2">
          <FormFieldSet
            label="Input"
            title="Description"
            type="textArea"
            placeholder="Enter Description"
            disabled={disabled}
            value={formData.description}
            onChange={(value) => handleChange("description", value)}
          />
        </div>
      </div>

      <div className="self-end xl:mr-40">
        <Button type="button" title={buttonText} onClick={handleButtonClick} />
      </div>
    </div>
  );
};

export default GeneralDetails;
